
import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useState } from "react";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { MessageType } from "types/enum";
import { getInventoryRequest, postResendJobOrder } from "./api";



export const InventoryRequests = () => {
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<any>([]);
    const [selectedObj, setSelectedObj] = useState<string | any>(null);
    const [mode, setMode] = useState("");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [showInventoryRequestForm, setShowInventoryRequestForm] = useState(false);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [search, setsearch] = useState(null);
    const [filterAndSort, setFilterAndSort] = useState<any>(null);
    const layoutContext = useContext(LayoutContext);
    const [pages, setPages] = useState<number>(0);

    const searchHandler = (str) => {
        setPageNum(1);
        setSelectedObj(null)
        if (str === "") {
            setsearch(null)
            getInventoryRequestsAsync(1, null);
        } else {
            setsearch(str)
            getInventoryRequestsAsync(1, str);
        }
    }
const postResendJobOrderAsync=async()=>{
    try{
        await postResendJobOrder(selectedObj?.Id)
    }
    catch(error){}
}
    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("InventoryRequestList", e.currentTarget.value)
        getInventoryRequestsAsync(1);
    };
    const handleGoPage = (value) => {
        if (value) {
            setPageNum(+value);
            getInventoryRequestsAsync(+value);
        } else {
        }
    };
    const handleNextPage = () => {
        if (response.TotalRecords && ((response.TotalRecords / pageSize) > pageNum)) {
            setPageNum((pageNum) => { return +pageNum + 1 });
            getInventoryRequestsAsync(pageNum + 1);

        }
    };
    const handlePrevPage = () => {
        if (pageNum > 1) {
            setPageNum((pageNum) => { return +pageNum - 1 });
            getInventoryRequestsAsync(pageNum - 1);
        }
    };



    const selectedObjCallback = (obj, index) => {
        setSelectedObj(obj);
    }

    const handleCreateInventoryRequest = (id) => {
        setMode("create");
        setShowInventoryRequestForm(true)
    }


    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel": downloadCSV(response?.Data ,6 ,trans("InventoryRequestList")); break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateInventoryRequest(""); break;
            case "view": if (selectedObj) {  setMode("view");setShowInventoryRequestForm(true) } else {
                //  Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning)

                 } break;
            // case "edit": if (selectedObj){setMode("edit");setShowInventoryRequestForm(true)}; break;
            case "help": alert("call api help"); break;

        }
    };
    /* #endregion */


    async function getInventoryRequestsAsync(pagNum = pageNum, searchSTR = search) {
        setLoading(false)
        try {
        let pageSizeChangedByUser = getPageSize("InventoryRequestList")
        setPageSize(pageSizeChangedByUser)
        if(layoutContext.currentApplication!=undefined){
            const res = await getInventoryRequest(pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist)
            if (res.Data.Data.length > 0) {
                setResponse(res.Data)
                
                setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
                
            }
        }
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)

    }
    useEffect(() => {
        setSelectedObj(null)
        setResponse(null)
        if(filterAndSort!=null&&layoutContext.currentApplication!=undefined){
            getInventoryRequestsAsync();
        }
    }, [forceUpdate, filterAndSort ,layoutContext.currentApplication]);
    useEffect(() => {
        let settings = getGridSetting("InventoryRequestList")
        setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] })

    }, []);


    return (
        <>  


            <Toolbar  
            // edit={true}
            view={true} handleSearch={searchHandler} id={selectedObj} emptyList={response?.TotalRecords == 0} search={true} handleClickToolbar={clickToolbarCallback} />
            <div style={{ overflowY: "auto", 
          height: "70vh",
           scrollbarWidth: "thin" }} className="col-lg-12 mt-0">
                {loading ? <>{
                    response?.Data?.length > 0 ?
                        <div className="card">
                            <div className="card-body p-0">
                                <>
                                    <DataGrid
                                        DoubleClick={(obj) => { setSelectedObj(obj); clickToolbarCallback("view") }}
                                        View={true}
                                        ViewParametr={"NotSeen"}
                                        handlefiltering={(str:any) => {str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                                        filterStr={filterAndSort.Filterlist}
                                        orderFormatList={filterAndSort.OrderFormat}
                                        orderFormat={(order) => { setFilterAndSort({ ...filterAndSort, OrderFormat: order }) }}
                                        parentName={"InventoryRequestList"}
                                        theadData={Object.keys(response.Data[0])}
                                        tbodyData={response.Data}
                                        minCellWidth={80}
                                        selectedRowObjectCallback={selectedObjCallback}
                                        rowSelected={selectedObj}
                                        startIndex={8}
                                        handleView={(e)=>{ setSelectedObj({Id:e}) ;setMode("view");setShowInventoryRequestForm(true)}}
                                        handleResend={postResendJobOrderAsync}
                                        totalRecords={response.TotalRecords}
                                        pageNum={pageNum}
                                        pageSize={pageSize}
                                        HandleNextPage={handleNextPage}
                                        HandlePrevPage={handlePrevPage}
                                        handlechangePageSize={handleChangePageSize}
                                        first={() => { getInventoryRequestsAsync(pages); setPageNum(pages) }}
                                        end={() => { getInventoryRequestsAsync(1); setPageNum(1) }}
                                        handleGoPage={handleGoPage}
                                    />
                                </>
                            </div>
                        </div>
                        :<Message message={"NoDataForPreview"} type={messageType} />
                        
                }</>
                    : <Loading />
                }
            </div>
        </>

    );
}